export default __webpack_public_path__ + "static/media/freedom_swing.b0852d91.png";